import React, { useState, useEffect } from 'react';
import { FoodMenu } from '../components';
import { Desayuno } from '../constants';

import { client } from '../client'

// Paquete para traduccion i18n
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from '../components';

const Desayunos = () => {
  // Hook importado de 'react-i18next'
  const { t } = useTranslation();

  const [comida, setComida] = useState([])

  useEffect(() => {
    const query ='*[_type == "desayuno"]'

    client.fetch(query)
      .then((data) => { setComida(data) })
  }, [])
  

  return (
    <div>
      <div className='flex-col flex justify-between lg:mx-96 bg-primary bg-opacity-10 min-h-screen'>
        <div className='mt-28 flex flex-col gap-3 mb-16'>
        <div className='flex justify-center'>
          <div className='scale-75 bg-white rounded-full p-3'>
            <LanguageSelector />
          </div>
        </div>
        <h1 className='text-center font-bold text-purple-700'>{t('desayuno')}</h1>
        { comida.map((food) => (
          <FoodMenu glb={Desayuno[food.id].glb}  portada={Desayuno[food.id].portada} titulo={Desayuno[food.id].nombre} descripcion={Desayuno[food.id].descripcion} precio={food.precio} key={food.id} principal={Desayuno[food.id].principal}/>
        ))}
        </div>
      </div>
    </div>
  )
}

export default Desayunos;